// One place that turns a dollar amount into $1.2K / $737.5M / $1.25B, so no page scales by hand. Uses the
// browser's own Intl compact notation (CLDR), so the unit follows the size of the number: the same card
// reads $950M this month and $1.02B when it crosses a billion.
const formatters = new Map<number, Intl.NumberFormat>();

function currencyFormatter(maximumFractionDigits: number): Intl.NumberFormat {
  let f = formatters.get(maximumFractionDigits);
  if (!f) {
    f = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      notation: "compact",
      minimumFractionDigits: 0,
      maximumFractionDigits,
    });
    formatters.set(maximumFractionDigits, f);
  }
  return f;
}

/** $1.2K, $737.5M, $1.25B. One decimal up to millions, two for billions. */
export function formatCompactCurrency(value: number): string {
  if (!Number.isFinite(value)) return "-";
  return currencyFormatter(Math.abs(value) >= 1e9 ? 2 : 1).format(value);
}
